module.exports = __webpack_public_path__ + "img/yessenialopez.ac498469.jpg";